<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      d="M14,13.75,2,1.75"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    />
    <path
      d="M2,13.75l12-12"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
</template>
